import makeFlex from "./flex"

const Flex = makeFlex("div")

export default Flex
